import { BadgeStep } from "components/atoms/Badge"

export const PixelImplementationStep = () => {
    return (
        <section className="border rounded-lg border-gray-700 pt-6 w-full p-4">
            <h3 className="text-md font-semibold mb-3">Implementation Steps Guide</h3>
            <div className="flex flex-col text-gray-300">
                <BadgeStep title='Copy your pixel code' text='Copy your pixel code' icon='copy' />
                <BadgeStep title='add code to your website' text="Add the code to your website's HTML, preferably in the &lt;head&gt; section" icon='code' />
                <BadgeStep title='register your urls' text="Add the URLs where you want to track visitors" icon='url' />
                <BadgeStep isLast title='check visitor activity' text="Check the Leads section to see if visitors are being tracked" icon='check' />
            </div>
        </section>
    )
}